import { SVGProps, useEffect, useState } from 'react'
import { JSX } from 'react/jsx-runtime'
import { IconBrandTiktok } from '@tabler/icons-react'
import { Icon } from '@/assets/icons'
import FadeInView from 'components/FadeInView'

const navigation = {
  movies: [
    { name: 'New Releases', href: '/movie/new-releases' },
    { name: 'All Movies', href: '/movie/blue-fox-canada' },
  ],
  companies: [
    { name: 'Blue Fox Entertainment Group', href: 'https://www.bluefoxentertainment.com' },
    { name: 'Shop', href: 'https://unobstructedview.com' },
  ],
  company: [
    { name: 'About', href: '/about' },
    { name: 'Press', href: '/press' },
  ],
  legal: [
    { name: 'Terms of service', href: '#' },
    { name: 'Privacy policy', href: '#' },
    { name: 'License', href: '#' },
  ],
  social: [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/profile.php?id=61575922139066',
      icon: (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
        <svg
          fill='currentColor'
          viewBox='0 0 24 24'
          {...props}
        >
          <path
            fillRule='evenodd'
            d='M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z'
            clipRule='evenodd'
          />
        </svg>
      ),
    },
    {
      name: 'TikTok',
      href: 'https://www.tiktok.com/@bluefoxentertainment', // ← your handle
      icon: (props: React.SVGProps<SVGSVGElement>) => (
        <IconBrandTiktok
          {...props}
          stroke={1.75}
        />
      ),
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/bluefoxca/ ',
      icon: (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
        <svg
          fill='currentColor'
          viewBox='0 0 24 24'
          {...props}
        >
          <path
            fillRule='evenodd'
            d='M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z'
            clipRule='evenodd'
          />
        </svg>
      ),
    },
    {
      name: 'YouTube',
      href: 'https://www.youtube.com/channel/UCmHYPCM_h8Tw9JkI3UnrCvA',
      icon: (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
        <svg
          fill='currentColor'
          viewBox='0 0 24 24'
          {...props}
        >
          <path
            fillRule='evenodd'
            d='M21.7 8.037a4.26 4.26 0 0 0-.789-1.964 2.84 2.84 0 0 0-1.984-.839c-2.767-.2-6.926-.2-6.926-.2s-4.157 0-6.928.2a2.836 2.836 0 0 0-1.983.839 4.225 4.225 0 0 0-.79 1.965 30.146 30.146 0 0 0-.2 3.206v1.5a30.12 30.12 0 0 0 .2 3.206c.094.712.364 1.39.784 1.972.604.536 1.38.837 2.187.848 1.583.151 6.731.2 6.731.2s4.161 0 6.928-.2a2.844 2.844 0 0 0 1.985-.84 4.27 4.27 0 0 0 .787-1.965 30.12 30.12 0 0 0 .2-3.206v-1.516a30.672 30.672 0 0 0-.202-3.206Zm-11.692 6.554v-5.62l5.4 2.819-5.4 2.801Z'
            clipRule='evenodd'
          />
        </svg>
      ),
    },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/blue-fox-entertainment/',
      icon: (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
        <svg
          fill='currentColor'
          viewBox='0 0 24 24'
          {...props}
        >
          <path
            fillRule='evenodd'
            d='M12.51 8.796v1.697a3.738 3.738 0 0 1 3.288-1.684c3.455 0 4.202 2.16 4.202 4.97V19.5h-3.2v-5.072c0-1.21-.244-2.766-2.128-2.766-1.827 0-2.139 1.317-2.139 2.676V19.5h-3.19V8.796h3.168ZM7.2 6.106a1.61 1.61 0 0 1-.988 1.483 1.595 1.595 0 0 1-1.743-.348A1.607 1.607 0 0 1 5.6 4.5a1.601 1.601 0 0 1 1.6 1.606Z'
            clipRule='evenodd'
          />
          <path d='M7.2 8.809H4V19.5h3.2V8.809Z' />
        </svg>
      ),
    },
  ],
}

export default function Footer() {
  // State to hold the current year
  const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear())

  // Update the year dynamically
  useEffect(() => {
    const year = new Date().getFullYear()
    setCurrentYear(year)
  }, [])

  return (
    <footer className="bg-slate-25 dark:bg-gray-925">
      {/* constrain the whole footer to the same width as the main content */}
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 pb-8 pt-20 sm:pt-24 lg:pt-32">
        {/* Logo */}
        <FadeInView><div className="flex items-center gap-3 mb-12">
          <img src={Icon} alt="Blue Fox Entertainment" className="w-10 h-10 brightness-0 dark:brightness-0 dark:invert" />
          <span className="text-sm font-bold tracking-[0.12em] uppercase text-gray-900 dark:text-gray-100">
            Blue Fox Entertainment Canada
          </span>
        </div></FadeInView>

        <FadeInView delay={0.1}><div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="grid grid-cols-2 gap-8 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">Our Catalog</h3>
                <ul className="mt-6 space-y-4">
                  {navigation.movies.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">Learn More</h3>
                <ul className="mt-6 space-y-4">
                  {navigation.companies.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">Company</h3>
                <ul className="mt-6 space-y-4">
                  {navigation.company.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">Legal</h3>
                <ul className="mt-6 space-y-4">
                  {navigation.legal.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-10 xl:mt-0">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              Subscribe to our YouTube Channel
            </h3>
            <div className="flex flex-col space-y-4 mt-6">
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Watch all trailers and new releases on our YouTube channel
              </p>
              <a
                href="https://www.youtube.com/channel/UCmHYPCM_h8Tw9JkI3UnrCvA?sub_confirmation=1"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex shrink-0 self-start items-center gap-1.5 rounded-sm
                           bg-red-600 text-white hover:bg-red-700
                           px-2.5 py-1.5 text-xs font-semibold
                           w-auto max-w-fit transition-all duration-200
                           shadow-sm hover:shadow-md
                           ring-1 ring-red-600 hover:ring-red-700"
              >
                <div className="flex items-center justify-center w-5 h-5 rounded-sm bg-white/20">
                  <svg viewBox="0 0 24 24" className="h-3 w-3" fill="currentColor">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
                <span>Subscribe on YouTube</span>
                <svg
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
                >
                  <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        </div></FadeInView>

        {/* bottom divider + meta (also constrained) */}
        <div className="mt-16 border-t border-gray-200 pt-8 sm:mt-20 md:flex md:items-center md:justify-between lg:mt-24 dark:border-gray-700">
          <div className="flex gap-x-6 md:order-2">
            {navigation.social.map((item) => (
              <a key={item.name} href={item.href} className="text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white">
                <span className="sr-only">{item.name}</span>
                <item.icon aria-hidden="true" className="size-6" />
              </a>
            ))}
          </div>
          <p className="mt-8 text-sm text-gray-600 md:order-1 md:mt-0 dark:text-gray-400">
            &copy; {currentYear} Blue Fox Entertainment, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
